"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStyled = exports.ContainerStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
var _borders = require("../style/borders");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ContainerStyled = exports.ContainerStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__ContainerStyled",
  componentId: "bufferapp-ui__sc-16jg64a-0"
})(["width:100%;height:8px;background-color:", ";border-radius:", ";margin:16px 0px;overflow:hidden;"], _colors.grayLight, _borders.borderRadius);
const ProgressStyled = exports.ProgressStyled = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__ProgressStyled",
  componentId: "bufferapp-ui__sc-16jg64a-1"
})(["background-color:", ";height:100%;width:", ";border-radius:", ";"], _colors.gray, props => props.progress || '100%', _borders.borderRadius);